import { render, staticRenderFns } from "./CategoryTasks.vue?vue&type=template&id=16eb85e3&"
import script from "./CategoryTasks.vue?vue&type=script&lang=js&"
export * from "./CategoryTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports